import type {
  RawTicketingAggregations,
  TicketingAggregations,
} from "@/features/boutique/types/ticketing.type";

export const transformAggregations = (
  raw: RawTicketingAggregations,
): TicketingAggregations => ({
  genres: raw.genres.buckets.map((bucket) => ({
    key: bucket.key,
    label: bucket.label,
    count: bucket.count,
  })),
  sousgenres: raw.sousgenres.buckets.map((bucket) => ({
    key: bucket.key,
    label: bucket.label,
    count: bucket.count,
  })),
  regions: raw.regions.buckets.map((bucket) => ({
    key: bucket.key,
    label: bucket.label,
    count: bucket.count,
  })),
  cities: raw.cities.buckets.map((bucket) => ({
    key: bucket.key,
    label: bucket.label,
    count: bucket.count,
  })),
  priceRanges: raw.price_ranges.buckets,
  dateRanges: raw.date_ranges.buckets,
});

export const getDefaultAggregations = (): TicketingAggregations => ({
  genres: [],
  sousgenres: [],
  regions: [],
  cities: [],
  priceRanges: [],
  dateRanges: [],
});
